import { CampaignTypes, ToneTypes } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  fields: {
    title: {
      label: 'Titolo',
      placeholder: 'Inserisci il titolo della notifica',
    },
    body: {
      label: 'Corpo del messaggio',
      placeholder: 'Inserisci il tuo messaggio',
    },
    promo_code: {
      label: 'Codice promo',
      placeholder: 'Seleziona codice promo',
    },
    offers: {
      label: 'Offerte',
      placeholder: 'Seleziona offerta',
    },
    campaign_type: {
      label: 'Tipo di campagna',
      placeholder: 'Seleziona tipo di campagna',
    },
    tone: {
      label: 'Tono di voce',
      placeholder: 'Seleziona un tono',
    },
  },
  attachment: {
    heading: 'Cosa deve promuovere questa campagna?',
    offer: {
      title: 'Offerta',
      description: 'Scegli dalle tue offerte attive.',
    },
    promo_code: {
      title: 'Codice promo',
      description: 'Scegli dai tuoi codici promo attivi.',
    },
  },
  buttons: {
    generate: 'Genera',
    improve: "Migliora con l'IA",
    undo: 'Annulla ({{count}})',
  },
  tone_options: {
    [ToneTypes.Friendly]: 'Amichevole 🙂',
    [ToneTypes.Elegant]: 'Elegante ✨',
    [ToneTypes.Playful]: 'Giocoso 🎉',
    [ToneTypes.Professional]: 'Professionale 👨‍💼',
    [ToneTypes.Informative]: 'Informativo 📊',
    [ToneTypes.Persuasive]: 'Persuasivo 💪',
  },
  campaign_types: {
    [CampaignTypes.Promotional]: 'Promozionale 🚀',
    [CampaignTypes.Informational]: 'Informativo ℹ️',
  },
  no_promo_codes: {
    title: 'Nessun codice promo idoneo',
    description: 'Crea un nuovo codice promo.',
    create_promo_code: 'Crea codice promo',
  },
  no_offers: {
    title: 'Nessuna offerta attiva',
    description: 'Crea una nuova offerta.',
    create_offer: 'Crea offerta',
  },
  feedback: {
    success: 'Generato con successo',
    error: 'Generazione fallita',
  },
};
